import React from 'react'
import PropTypes from 'prop-types'

const VIP_STYLE = {
    color: '#f1c40f',
}


const VipIcon = ({ active, onClick = () => {} }) => {
    if (active) {
        return (<i className="fa fa-star" onClick={onClick} style={VIP_STYLE}/>)
    }
    return (<i className="fa fa-star-o" onClick={onClick} style={VIP_STYLE}/>)
}


VipIcon.propTypes = {
    active: PropTypes.bool,
    onClick: PropTypes.func,
}

export default VipIcon



// WEBPACK FOOTER //
// ./src/modules/form/component/VipIcon.js